export default "__VITE_ASSET__w520E2r7__"